module.exports = __webpack_public_path__ + "img/category-2.d00cbff3.svg";